import "./assets/styles/App.css";
import GameBoard from "./components/GameBoard";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Modal from "./components/Modal";

function App() {
  return (
    <div className="App">
      <Header />
      <GameBoard />
      <Footer />
      <Modal />
    </div>
  );
}

export default App;
